import {useCallback, useMemo, useState} from "react";
import ApiServiceV2 from "../services/ApiServiceV2";
import {AxiosResponse} from "axios";
import {routes} from "./routes";
import {AxiosError} from "axios";

export const useFetchData = <DataType>(
    url: keyof typeof routes,
) => {
    //states to fetch and store fonts
    const [data, setData] = useState<DataType[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string|null>(null)
    const [pagination, setPagination] = useState<{total: number, perPage: number, currentPage: number, lastPage: number}|null>(null)
    const api = useMemo(() => {
        return new ApiServiceV2()
    }, [])

    //api call
    const handleFetchData = useCallback( (params?: Record<string, string>,) => {
        setIsLoading(true)
        setError(null)
        let finalUrl: string = routes[url]

        if (params) {
            const filtered: Record<string, string> = {}
            Object.keys(params).forEach(key => {
                if (params[key]) {
                    filtered[key] = params[key]
                }
            })
            finalUrl = routes[url] + '?' + new URLSearchParams(filtered).toString()
        }

        api.callApi(finalUrl).then((response: AxiosResponse<any>) => {
            if (response.data?.data) {
                setData(response.data.data)
                setPagination(response.data.pagination)
            }
        }).catch((error: AxiosError) => {
            setError('['+error.response?.status+']: '+ error.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [api, url])

    return {
        data,
        isLoading,
        error,
        fetch: handleFetchData,
        pagination
    }
}
